<template>
	<div class="page-main">
		<div class="main-head">
			<div class="breakcrumbs">联盟院校  >  机构主页</div>
			<!-- <div class="back-btn">返回</div> -->
		</div>
		
		<m-second :datas="secondInfo" @changeNav="changeNav">
			<div class="detail-ctn" v-if="detail">
				<h3 class="title">{{detail.contentTitle}}</h3>
				<div class="ctn" v-html="detail.contentDesc"></div>
			</div>
			<van-empty v-if="!detail" description="暂无内容" />
		</m-second>

	</div>
</template>

<script>
import mSecond from '@/components/second.vue'
export default {
	name: 'newsList',
	components:{
		mSecond
	},
	data () {
		return {
			firstCateId:'',	//一级栏目id
			secondInfo:{
				title:'',
				list:[
					// { title:'新闻动态',  },
					// { title:'政策文件',  }
				],
				columnId:''	//二级栏目id
			},
			listInfo:{
				list:[],
				pageNum:1,
				pageSize:10,
				total:0
			},
			pagingList:[],
			pagingIndex:0,
			
			detail:null
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.firstCateId = this.$route.query.firstCateId
		this.getSecondColumnList()
		this.getColumnTitle()
	},
	
	watch:{
		$route(to,from){
			this.firstCateId = to.query.firstCateId
			this.getSecondColumnList()
			this.getColumnTitle()
		},
	},
  
  
	methods:{
		//获取一级栏目名称
		getColumnTitle(){
			const { navList } = this.$store.state
			let { firstCateId } = this
			let parentName = ''
			navList.forEach(item=>{
				if(item.columnId == firstCateId){
					parentName = item.columnName
				}
			})
			this.secondInfo.title = parentName
			this.$store.commit('changeNavId',firstCateId)
		},
		
		//查询二级栏目
		getSecondColumnList(){
			let { firstCateId } = this
			//获取二级栏目列表
			this.$axios({
				url:`/jxedu/api/site/secondColumnList/${firstCateId}`,
			}).then(res=>{
				let list = res.data
				let infoList = []
				list.forEach((item,index)=>{
					infoList.push({
						title:item.columnName,
						columnId:item.columnId
					})
				})
				this.secondInfo.list = infoList
				const { secondCateId } = this.$route.query	
				this.secondInfo.columnId = secondCateId || infoList[0].columnId
				this.getNewList()
			})
		},
		
		//查询门户首页二级栏目数据
		getNewList(){
			const {  pageSize, pageNum } = this.listInfo
			const { columnId } = this.secondInfo
			this.$axios({
				url:`/jxedu/api/site/columnContents`,
				params:{
					columnId,
					pageNum,
					pageSize
				}
			}).then(res=>{
				let list = res.data.rows || []
				if(list.length>0){
					const { contentId } = list[0]
					this.getDetail(contentId)
				}
			})
		},
		
		//获取新闻详情
		getDetail(contentId){
			this.$axios({
				url:`/jxedu/api/site/findById/${contentId}`,
			}).then(res=>{
				let detail = res.data
				this.detail = detail
			})
		},
		
		//改变左侧菜单栏
		changeNav(columnId){
			this.goUrl({ name:'about', query:{firstCateId:this.firstCateId, secondCateId: columnId}})
			// this.secondInfo.columnId = columnId
			// this.getNewList()
		}
		
	}
}
</script>

<style lang="less" scoped>
.detail-ctn{
	font-size:16px; color:#333; line-height:24px; padding-bottom:28px;
	.title{ font-size:24px; line-height:36px; color:#333333; text-align:center; margin-bottom:60px; font-weight: bold; }
	p{ margin-bottom:20px; }
	/deep/ img{ max-width:100%;}
}
</style>



// WEBPACK FOOTER //
// src/pages/about/tpl-pc.vue